import { Text, TextSize } from 'shared/ui/Text/Text';
import { AppLink, AppLinkTheme } from 'shared/ui/AppLink/AppLink';
import BackIcon from 'shared/assets/icons/backIcon.svg';
import cls from './InfoCard.module.scss';

interface IInfoCardProps {
    img: string,
    text: string,
}

export const InfoCard = ({ img, text }: IInfoCardProps) => {
    return (
        <div className={cls.card}>
            <div className={cls.imgBox}>
                <img src={img} className={cls.img} alt="Разумные деньги фото №3" />
            </div>
            <Text className={cls.text} color="#353850" size={TextSize.text_24}>
                {text}
            </Text>
            <AppLink
                className={cls.button}
                to="/shop"
                icon={<BackIcon />}
                theme={AppLinkTheme.BACK}
            >
                В магазин
            </AppLink>
        </div>
    );
};
